import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd';

const JoinGroupModal = ({ visible, onClose, onJoinGroup }) => {
    const [groupCode, setGroupCode] = useState('');

    const handleJoinGroup = () => {
        onJoinGroup(groupCode);  // Call the parent handler  
    };

    return (
        <Modal
            title="Join Group"
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="join" type="primary" onClick={handleJoinGroup}>
                    Join
                </Button>,
            ]}
        >
            <Input
                placeholder="Enter Group Code"
                value={groupCode}
                onChange={(e) => setGroupCode(e.target.value)}
            />
        </Modal>
    );
};

export default JoinGroupModal;  
